import React from "react";

interface LocationItemProps {
    location: {
        name: string,
        href: string,
        backgroundImg: string,
    };
}

const LocationItem: React.FC<LocationItemProps> = ({ location }) => {
    const { name, href, backgroundImg } = location;
    return (
        <div className="col-12 col-md-6 p-2">
            <div className="location-wrapper">
                <a href={href} title={`Immobili a ${name}`}>
                    <div className="location-item bg-holder" style={{ backgroundImage: `url(${backgroundImg})` }}>
                        <div className="location-item-info">
                            <h6 className="location-item-title">{name}</h6>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default LocationItem;